import React  from 'react';
import { connect } from 'react-redux';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import combinedShape from './images/combined-shape.svg';

const TechnicianTimeSlots = (props) =>  {

    return (
        <div className="technician-time-slots">
            <span className="icon" style={{backgroundImage:combinedShape.bg()}}></span>
            {props.technicianTimeSlots?.isBezeqWithCellcom && <p>שמו לב, מועד טכנאי {window.Config.brand_Name_HE} יהיה לאחר 48 שעות מהמועד שתבחרו כאן</p>}
            <div className="slots-wrapper">
            <div className="slots">
                {props.timeSlots?.map((slot, key) => (
                    <div key={slot.localId} className="slot">
                    <RadioInput 
                        onChange={() => props.onSelectedTimeSlot(slot)}
                        id={slot.localId}
                        name='slots'
                        value={slot.displayDate}
                        label={slot.displayDate}
                        checked={props.currentSelectedTimeSlot?.localId == slot.localId}
                    />
                    </div>
                ))} 
            </div>
            </div>
            <div className="btn-wrapper">
            {props.technicianTimeSlotPage.isDisplayShowMoreBtn && <button className="show-more-slots-btn" onClick={() => {props.onClickShowMoreTimeSlotsBtn()}}>הצג עוד מועדים</button>}
            {props.showNotChooseTimeSlotErrorMsg &&  <p className="error-msg">על מנת להמשיך יש לבחור מועד</p>}
            <BtnSubmit onclick={() =>props.updateTechnicianVisit()} text="עדכן" formid="technician-time-slots"></BtnSubmit>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        timeSlots : state.technicianUpdatesBlock.technicianTimeSlotPage.timeSlots,
        technicianTimeSlots : state.technicianUpdatesBlock.technicianTimeSlots,
        currentSelectedTimeSlot: state.technicianUpdatesBlock.currentSelectedTimeSlot,
        technicianTimeSlotPage: state.technicianUpdatesBlock.technicianTimeSlotPage
    };
  };
  
  const mapDispatchToProps = {
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(TechnicianTimeSlots);